import React from "react";
import InvesticneZlozenieGrafKarta from "./InvesticneZlozenieGrafKarta";
import InvesticneVyvojGrafKarta from "./InvesticneVyvojGrafKarta";

const InvesticneGrafickeZobrazenieKarta =
  React.forwardRef(
    function InvesticneGrafickeZobrazenieKarta(
      {
        vysledok,
        vysledkyInvesticii,
        porovnanieInvesticii,
        nastaveniaVariantov,
      },
      ref
    ) {
      const [
        grafickeZobrazenieRezim,
        setGrafickeZobrazenieRezim,
      ] = React.useState(
        "zlozenie"
      );

      const zlozenieGrafRef =
        React.useRef(null);

      const vyvojGrafRef =
        React.useRef(null);

      const zobrazujeVyvoj =
        grafickeZobrazenieRezim ===
        "vyvoj";

      React.useImperativeHandle(
        ref,
        () => ({
          ziskajPdfGrafy: () => ({
            zlozenie:
              zlozenieGrafRef.current
                ?.ziskajPdfData?.() ||
              null,
            vyvoj:
              vyvojGrafRef.current
                ?.ziskajPdfData?.() ||
              null,
          }),
        }),
        []
      );

      return (
        <div className="card-section card-section--invest-graf">
          <div className="card-header invest-graf-head">
            <h2>
              Grafické zobrazenie výsledku
            </h2>

            <div
              className="applicant-tabs invest-graf-tabs"
              role="tablist"
              aria-label="Typ grafického zobrazenia"
            >
              <button
                type="button"
                role="tab"
                aria-selected={
                  !zobrazujeVyvoj
                }
                className={`applicant-tab ${
                  !zobrazujeVyvoj
                    ? "is-active"
                    : ""
                }`}
                onClick={() =>
                  setGrafickeZobrazenieRezim(
                    "zlozenie"
                  )
                }
              >
                Zloženie
              </button>

              <button
                type="button"
                role="tab"
                aria-selected={
                  zobrazujeVyvoj
                }
                className={`applicant-tab ${
                  zobrazujeVyvoj
                    ? "is-active"
                    : ""
                }`}
                onClick={() =>
                  setGrafickeZobrazenieRezim(
                    "vyvoj"
                  )
                }
              >
                Vývoj
              </button>
            </div>
          </div>

          <div className="invest-graf-panels">
            <div
              className={`invest-graf-panel ${
                zobrazujeVyvoj
                  ? "is-hidden"
                  : ""
              }`}
              aria-hidden={
                zobrazujeVyvoj
              }
            >
              <InvesticneZlozenieGrafKarta
                ref={zlozenieGrafRef}
                vysledok={vysledok}
                vysledkyInvesticii={
                  vysledkyInvesticii
                }
                porovnanieInvesticii={
                  porovnanieInvesticii
                }
              />
            </div>

            <div
              className={`invest-graf-panel ${
                !zobrazujeVyvoj
                  ? "is-hidden"
                  : ""
              }`}
              aria-hidden={
                !zobrazujeVyvoj
              }
            >
              <InvesticneVyvojGrafKarta
                ref={vyvojGrafRef}
                vysledok={vysledok}
                vysledkyInvesticii={
                  vysledkyInvesticii
                }
                porovnanieInvesticii={
                  porovnanieInvesticii
                }
                nastaveniaVariantov={
                  nastaveniaVariantov
                }
              />
            </div>
          </div>
        </div>
      );
    }
  );

export default
  InvesticneGrafickeZobrazenieKarta;